export * from "./sortable";

const FORBID_DRAG_ON = ["INPUT", "TEXTAREA"];
export const canStartDrag = () => {
  if (document.activeElement) {
    const tagName = (document.activeElement as HTMLElement).tagName;
    if (
      FORBID_DRAG_ON.includes(tagName) ||
      (tagName === "DIV" && (document.activeElement as HTMLDivElement).contentEditable === "true")
    ) {
      return false;
    }
  }

  return true;
};
